export const DEFAULT_TAB_TITLE = 'Autodesk Construction Cloud';
//# sourceMappingURL=consts.js.map